module.exports = __webpack_public_path__ + "static/media/cc.c2c3a8e2.svg";